import {Button, Form} from "react-bootstrap";
import {useDesignServiceState} from "../../../../hooks/useDesignServiceState";
import * as React from "react";
import {useAppDispatch, useCartStatus, useDesignServiceId} from "../../../../redux/stateHooks";
import {CartItemResourceType} from "../../../../api/cart";
import {GPAWebDataTypesResourceType} from "../../../../api/openApi/cartService";
import {useCartService} from "../../../../hooks/addToCart/useCartService";
import {useCartItemDesignService} from "../../../../hooks/addToCart/useCartItemDesignService";
import {useOffCanvasDesignService} from "../../../../hooks/addToCart/useOffCanvasDesignService";
import {setDesignService} from "../../../../redux/slices/addToCart";
import {AddToCartDesignServicesContent} from "./addToCartDesignServicesContent";
import {DesignServicesSelectedOffer} from "./designServicesSelectedOffer";

/**
 * The DesignServicesDetailsProps interface defines the props for the DesignServicesDetails component.
 * @param children Either the design services options or the cart item design services.
 */
interface DesignServicesDetailsProps {
    children: React.ReactNode;
}

/**
 * The AddToCartDesignServices component is used to display the design services options for a product.
 */
export const AddToCartDesignServices = () => {
    const {model: {breakOutEarly}} = useDesignServiceState();
    const model = useCartItemDesignService()
    const {designServices} = useOffCanvasDesignService()

    if (breakOutEarly) return <></>;

    if (designServices.length === 0)
        return <></>;

    return (
        <DesignServicesDetails>
            {model ?
                <DesignServicesSelectedOffer model={model}/> :
                <DesignServicesOffer/>
            }
        </DesignServicesDetails>
    )
}

/**
 * The DesignServicesDetails component is used to either display the current design services options or the cart item design services.
 * @param children Either the design services options or the cart item design services.
 */
const DesignServicesDetails: React.FC<DesignServicesDetailsProps> = ({children}: DesignServicesDetailsProps) => {
    return (
        <>
            <Form.Group className="pb-2">
                {children}
            </Form.Group>
        </>
    );
}

/**
 * The DesignServicesOffer component is used to display the design services options for a product.
 */
const DesignServicesOffer = () => {
    const dispatch = useAppDispatch();
    const designServiceId = useDesignServiceId()
    const {request} = useCartStatus()
    const {createItemResources} = useCartService()

    const cartDesignService = useCartItemDesignService()
    const {designServices} = useOffCanvasDesignService(designServiceId)
    const designService = designServices[0];

    const AcceptOffer = async () => {
        if (request) {
            const resources: CartItemResourceType[] = []
            if (!cartDesignService && designService) {
                resources.push({
                    resourceType: GPAWebDataTypesResourceType.DesignerService,
                    resourceId: designService.id,
                    resourcePrice: designService.price
                })
                dispatch(setDesignService(designService.id))
            }
            await createItemResources({...request, resources: resources})
        }
    }

    if (!designService)
        return <></>;

    return (
        <div className="border-top pt-2">
            {designServices.map((designService, index) => <AddToCartDesignServicesContent key={index}
                                                                                          model={designService}/>)}
            <div>
                <Button id="design-services-button" className="my-2" variant="outline-primary" onClick={async () => await AcceptOffer()}>Add Design
                    Services ({designService.formatted.price} per hour)</Button>
            </div>

        </div>
    )
}